export const SELECT_ORGANIZATION = 'SELECT_ORGANIZATION';
export const LOAD_ORGANIZATION = 'LOAD_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
